import React from 'react';
import DataTable, { createTheme } from 'react-data-table-component';
import Checkbox from '@material-ui/core/Checkbox';

import ArrowDownward from '@material-ui/icons/ArrowDownward';

const sortIcon = <ArrowDownward />;
const selectProps = { indeterminate: isIndeterminate => isIndeterminate };

createTheme('solarized', {
    text: {
      primary: 'var(--colScritte)',
      secondary: 'var(--colScritte)',
    },
    background: {
      default: 'var(--colSfondoBianco)',
    },
    context: {
      background: '#cb4b16',
      text: '#FFFFFF',
    },
    divider: {
      default: 'var(--colAlt)',
    },
    action: {
      button: 'var(--colAltScuro)',
      hover: 'rgba(0,0,0,.08)',
      disabled: 'rgba(0,0,0,.12)',
    }
  }, 'light');

  const tableCustomStyles = {
    headRow: {
      style: {
        /* color:'#223336',
        backgroundColor: '#e7eef0' */
      },
    },
    rows: {
      style: {
        color: "var(--colScritte)",
        backgroundColor: "transparent"
      },
      stripedStyle: {
        color: "var(--colScritte)",
        backgroundColor: "var(--colChiarissimo)"
      },
      selectedHighlightStyle: {
        // use nth-of-type(n) to override other nth selectors
			'&:nth-of-type(n)': {
				/* color: theme.selected.text, */
				backgroundColor: "var(--colAlt)",
				/* borderBottomColor: theme.background.default, */
			}
      }
    }
  }

function DataTableBase(props) {
    return (
        <DataTable
            pagination
            selectableRowsComponent={Checkbox}
            selectableRowsComponentProps={selectProps}
            sortIcon={sortIcon}
            striped
            theme="solarized"
            progressComponent={<h3 className='ma5 pa5 '>carico i dati...</h3>}
            customStyles={tableCustomStyles}
            //dense
            {...props}
        />
    );
}

export default DataTableBase;
